<div class="row" *ngIf="commentaire">
    <div class="col-6 d-flex">
        <!-- <ng-switchery *ngIf="!commentaire.Id && !readonly" class="mr-1 float-left" [(ngModel)]="topComment" size="switchery-sm" name="topComment">
        </ng-switchery> -->
        <switchery-ios *ngIf="!commentaire.Id && !readonly" [(ngModel)]="topComment" size="medium" name="topComment"></switchery-ios>
        <button *ngIf="commentaire.Id && !readonly" class="btn btn-xs btn-danger mr-1 float-left" style="width:30px;" btnDebounceClick (debounceClick)="removeComment()">
            <i class="fas fa-times-circle"></i>
        </button>
        <textarea *ngIf="topComment" class="form-control flex-grow-1" placeholder="Description" style="height: 40px;width:100%;"
            name="Comment" [(ngModel)]="commentaire.Comment"
            required [disabled]="commentaireDisabled"></textarea>
    </div>
    <div class="col-6 d-flex">
        <div class="flex-grow-1">
            <label *ngIf="creaContact">
                Ajouté le {{commentaire.CreaDate|date:'dd/MM/yyyy à HH:mm'}} par {{creaContact.Firstname}} {{creaContact.Lastname}}
            </label>
        </div>
        <button *ngIf="topComment && !commentaire.Id && !readonly" [disabled]="!canAdd" type="button" class="btn btn-sm btn-primary float-right mr-1" 
            btnDebounceClick (debounceClick)="btnAddComment()">
            Ajouter <i class="fas fa-plus-square ml-2"></i>
        </button>
    </div>
</div>